/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  assertIsInstructionWithAccounts,
  containsBytes,
  extendClient,
  fixEncoderSize,
  getBytesEncoder,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
  SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
  SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
  SolanaError,
  type Address,
  type ClientWithPayer,
  type ClientWithRpc,
  type ClientWithTransactionPlanning,
  type ClientWithTransactionSending,
  type GetAccountInfoApi,
  type GetMultipleAccountsApi,
  type Instruction,
  type InstructionWithData,
  type ReadonlyUint8Array,
} from "@solana/kit";
import {
  addSelfFetchFunctions,
  addSelfPlanAndSendFunctions,
  type SelfFetchFunctions,
  type SelfPlanAndSendFunctions,
} from "@solana/program-client-core";
import {
  getBetCodec,
  getEscrowCodec,
  getGlobalConfigCodec,
  getMarketCodec,
  type Bet,
  type BetArgs,
  type Escrow,
  type EscrowArgs,
  type GlobalConfig,
  type GlobalConfigArgs,
  type Market,
  type MarketArgs,
} from "../accounts";
import {
  getCancelMarketInstruction,
  getCloseCancelledMarketInstructionAsync,
  getCloseResolvedMarketInstructionAsync,
  getCreateMarketInstructionAsync,
  getDrainOracleReqPdaInstructionAsync,
  getInitializeConfigInstructionAsync,
  getMigrateConfigV2InstructionAsync,
  getMigrateConfigV3InstructionAsync,
  getPlaceBetInstructionAsync,
  getRefundBetInstructionAsync,
  getSettleBetInstructionAsync,
  getUpdateConfigInstructionAsync,
  parseCancelMarketInstruction,
  parseCloseCancelledMarketInstruction,
  parseCloseResolvedMarketInstruction,
  parseCreateMarketInstruction,
  parseDrainOracleReqPdaInstruction,
  parseInitializeConfigInstruction,
  parseMigrateConfigV2Instruction,
  parseMigrateConfigV3Instruction,
  parsePlaceBetInstruction,
  parseRefundBetInstruction,
  parseSettleBetInstruction,
  parseUpdateConfigInstruction,
  type CancelMarketInput,
  type CloseCancelledMarketAsyncInput,
  type CloseResolvedMarketAsyncInput,
  type CreateMarketAsyncInput,
  type DrainOracleReqPdaAsyncInput,
  type InitializeConfigAsyncInput,
  type MigrateConfigV2AsyncInput,
  type MigrateConfigV3AsyncInput,
  type ParsedCancelMarketInstruction,
  type ParsedCloseCancelledMarketInstruction,
  type ParsedCloseResolvedMarketInstruction,
  type ParsedCreateMarketInstruction,
  type ParsedDrainOracleReqPdaInstruction,
  type ParsedInitializeConfigInstruction,
  type ParsedMigrateConfigV2Instruction,
  type ParsedMigrateConfigV3Instruction,
  type ParsedPlaceBetInstruction,
  type ParsedRefundBetInstruction,
  type ParsedSettleBetInstruction,
  type ParsedUpdateConfigInstruction,
  type PlaceBetAsyncInput,
  type RefundBetAsyncInput,
  type SettleBetAsyncInput,
  type UpdateConfigAsyncInput,
} from "../instructions";
import {
  findBetPda,
  findConfigPda,
  findEscrowPda,
  findOracleReqPdaPda,
  findRefundBetBetPda,
} from "../pdas";

export const BETMEBRO_PROGRAM_ADDRESS =
  "D4Dq6ce6PwK7x51RpG5PVQkX3jD3pcteoEWR5LeSM7UQ" as Address<"D4Dq6ce6PwK7x51RpG5PVQkX3jD3pcteoEWR5LeSM7UQ">;

export enum BetmebroAccount {
  Bet,
  Escrow,
  GlobalConfig,
  Market,
}

export function identifyBetmebroAccount(
  account: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): BetmebroAccount {
  const data = "data" in account ? account.data : account;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([147, 23, 35, 59, 15, 75, 155, 32]),
      ),
      0,
    )
  ) {
    return BetmebroAccount.Bet;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([31, 213, 123, 187, 186, 22, 218, 155]),
      ),
      0,
    )
  ) {
    return BetmebroAccount.Escrow;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([149, 8, 156, 202, 160, 252, 176, 217]),
      ),
      0,
    )
  ) {
    return BetmebroAccount.GlobalConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([219, 190, 213, 55, 0, 227, 198, 154]),
      ),
      0,
    )
  ) {
    return BetmebroAccount.Market;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_ACCOUNT,
    { accountData: data, programName: "betmebro" },
  );
}

export enum BetmebroInstruction {
  CancelMarket,
  CloseCancelledMarket,
  CloseResolvedMarket,
  CreateMarket,
  DrainOracleReqPda,
  InitializeConfig,
  MigrateConfigV2,
  MigrateConfigV3,
  PlaceBet,
  RefundBet,
  SettleBet,
  UpdateConfig,
}

export function identifyBetmebroInstruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array,
): BetmebroInstruction {
  const data = "data" in instruction ? instruction.data : instruction;
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([205, 121, 84, 210, 222, 71, 150, 11]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.CancelMarket;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([80, 228, 100, 97, 20, 0, 228, 242]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.CloseCancelledMarket;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([56, 125, 62, 207, 76, 243, 35, 60]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.CloseResolvedMarket;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([103, 226, 97, 235, 200, 188, 251, 254]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.CreateMarket;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([222, 123, 141, 23, 244, 75, 189, 145]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.DrainOracleReqPda;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([208, 127, 21, 1, 194, 190, 196, 70]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.InitializeConfig;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([21, 39, 88, 172, 254, 205, 30, 141]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.MigrateConfigV2;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([78, 178, 126, 113, 62, 159, 225, 249]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.MigrateConfigV3;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([222, 62, 67, 220, 63, 166, 126, 33]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.PlaceBet;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([209, 182, 226, 96, 55, 121, 83, 183]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.RefundBet;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([115, 55, 234, 177, 227, 4, 10, 67]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.SettleBet;
  }
  if (
    containsBytes(
      data,
      fixEncoderSize(getBytesEncoder(), 8).encode(
        new Uint8Array([29, 158, 252, 191, 10, 83, 219, 99]),
      ),
      0,
    )
  ) {
    return BetmebroInstruction.UpdateConfig;
  }
  throw new SolanaError(
    SOLANA_ERROR__PROGRAM_CLIENTS__FAILED_TO_IDENTIFY_INSTRUCTION,
    { instructionData: data, programName: "betmebro" },
  );
}

export type ParsedBetmebroInstruction<
  TProgram extends string = "D4Dq6ce6PwK7x51RpG5PVQkX3jD3pcteoEWR5LeSM7UQ",
> =
  | ({
      instructionType: BetmebroInstruction.CancelMarket;
    } & ParsedCancelMarketInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.CloseCancelledMarket;
    } & ParsedCloseCancelledMarketInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.CloseResolvedMarket;
    } & ParsedCloseResolvedMarketInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.CreateMarket;
    } & ParsedCreateMarketInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.DrainOracleReqPda;
    } & ParsedDrainOracleReqPdaInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.InitializeConfig;
    } & ParsedInitializeConfigInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.MigrateConfigV2;
    } & ParsedMigrateConfigV2Instruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.MigrateConfigV3;
    } & ParsedMigrateConfigV3Instruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.PlaceBet;
    } & ParsedPlaceBetInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.RefundBet;
    } & ParsedRefundBetInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.SettleBet;
    } & ParsedSettleBetInstruction<TProgram>)
  | ({
      instructionType: BetmebroInstruction.UpdateConfig;
    } & ParsedUpdateConfigInstruction<TProgram>);

export function parseBetmebroInstruction<TProgram extends string>(
  instruction: Instruction<TProgram> & InstructionWithData<ReadonlyUint8Array>,
): ParsedBetmebroInstruction<TProgram> {
  const instructionType = identifyBetmebroInstruction(instruction);
  switch (instructionType) {
    case BetmebroInstruction.CancelMarket: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.CancelMarket,
        ...parseCancelMarketInstruction(instruction),
      };
    }
    case BetmebroInstruction.CloseCancelledMarket: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.CloseCancelledMarket,
        ...parseCloseCancelledMarketInstruction(instruction),
      };
    }
    case BetmebroInstruction.CloseResolvedMarket: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.CloseResolvedMarket,
        ...parseCloseResolvedMarketInstruction(instruction),
      };
    }
    case BetmebroInstruction.CreateMarket: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.CreateMarket,
        ...parseCreateMarketInstruction(instruction),
      };
    }
    case BetmebroInstruction.DrainOracleReqPda: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.DrainOracleReqPda,
        ...parseDrainOracleReqPdaInstruction(instruction),
      };
    }
    case BetmebroInstruction.InitializeConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.InitializeConfig,
        ...parseInitializeConfigInstruction(instruction),
      };
    }
    case BetmebroInstruction.MigrateConfigV2: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.MigrateConfigV2,
        ...parseMigrateConfigV2Instruction(instruction),
      };
    }
    case BetmebroInstruction.MigrateConfigV3: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.MigrateConfigV3,
        ...parseMigrateConfigV3Instruction(instruction),
      };
    }
    case BetmebroInstruction.PlaceBet: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.PlaceBet,
        ...parsePlaceBetInstruction(instruction),
      };
    }
    case BetmebroInstruction.RefundBet: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.RefundBet,
        ...parseRefundBetInstruction(instruction),
      };
    }
    case BetmebroInstruction.SettleBet: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.SettleBet,
        ...parseSettleBetInstruction(instruction),
      };
    }
    case BetmebroInstruction.UpdateConfig: {
      assertIsInstructionWithAccounts(instruction);
      return {
        instructionType: BetmebroInstruction.UpdateConfig,
        ...parseUpdateConfigInstruction(instruction),
      };
    }
    default:
      throw new SolanaError(
        SOLANA_ERROR__PROGRAM_CLIENTS__UNRECOGNIZED_INSTRUCTION_TYPE,
        { instructionType: instructionType as string, programName: "betmebro" },
      );
  }
}

export type BetmebroPlugin = {
  accounts: BetmebroPluginAccounts;
  instructions: BetmebroPluginInstructions;
  pdas: BetmebroPluginPdas;
};

export type BetmebroPluginAccounts = {
  bet: ReturnType<typeof getBetCodec> & SelfFetchFunctions<BetArgs, Bet>;
  escrow: ReturnType<typeof getEscrowCodec> &
    SelfFetchFunctions<EscrowArgs, Escrow>;
  globalConfig: ReturnType<typeof getGlobalConfigCodec> &
    SelfFetchFunctions<GlobalConfigArgs, GlobalConfig>;
  market: ReturnType<typeof getMarketCodec> &
    SelfFetchFunctions<MarketArgs, Market>;
};

export type BetmebroPluginInstructions = {
  cancelMarket: (
    input: CancelMarketInput,
  ) => ReturnType<typeof getCancelMarketInstruction> & SelfPlanAndSendFunctions;
  closeCancelledMarket: (
    input: CloseCancelledMarketAsyncInput,
  ) => ReturnType<typeof getCloseCancelledMarketInstructionAsync> &
    SelfPlanAndSendFunctions;
  closeResolvedMarket: (
    input: CloseResolvedMarketAsyncInput,
  ) => ReturnType<typeof getCloseResolvedMarketInstructionAsync> &
    SelfPlanAndSendFunctions;
  createMarket: (
    input: CreateMarketAsyncInput,
  ) => ReturnType<typeof getCreateMarketInstructionAsync> &
    SelfPlanAndSendFunctions;
  drainOracleReqPda: (
    input: DrainOracleReqPdaAsyncInput,
  ) => ReturnType<typeof getDrainOracleReqPdaInstructionAsync> &
    SelfPlanAndSendFunctions;
  initializeConfig: (
    input: InitializeConfigAsyncInput,
  ) => ReturnType<typeof getInitializeConfigInstructionAsync> &
    SelfPlanAndSendFunctions;
  migrateConfigV2: (
    input: MigrateConfigV2AsyncInput,
  ) => ReturnType<typeof getMigrateConfigV2InstructionAsync> &
    SelfPlanAndSendFunctions;
  migrateConfigV3: (
    input: MigrateConfigV3AsyncInput,
  ) => ReturnType<typeof getMigrateConfigV3InstructionAsync> &
    SelfPlanAndSendFunctions;
  placeBet: (
    input: PlaceBetAsyncInput,
  ) => ReturnType<typeof getPlaceBetInstructionAsync> &
    SelfPlanAndSendFunctions;
  refundBet: (
    input: MakeOptional<RefundBetAsyncInput, "payer">,
  ) => ReturnType<typeof getRefundBetInstructionAsync> &
    SelfPlanAndSendFunctions;
  settleBet: (
    input: SettleBetAsyncInput,
  ) => ReturnType<typeof getSettleBetInstructionAsync> &
    SelfPlanAndSendFunctions;
  updateConfig: (
    input: UpdateConfigAsyncInput,
  ) => ReturnType<typeof getUpdateConfigInstructionAsync> &
    SelfPlanAndSendFunctions;
};

export type BetmebroPluginPdas = {
  escrow: typeof findEscrowPda;
  config: typeof findConfigPda;
  oracleReqPda: typeof findOracleReqPdaPda;
  bet: typeof findBetPda;
  refundBetBet: typeof findRefundBetBetPda;
};

export type BetmebroPluginRequirements = ClientWithRpc<
  GetAccountInfoApi & GetMultipleAccountsApi
> &
  ClientWithPayer &
  ClientWithTransactionPlanning &
  ClientWithTransactionSending;

export function betmebroProgram() {
  return <T extends BetmebroPluginRequirements>(
    client: T,
  ): Omit<T, "betmebro"> & { betmebro: BetmebroPlugin } => {
    return extendClient(client, {
      betmebro: <BetmebroPlugin>{
        accounts: {
          bet: addSelfFetchFunctions(client, getBetCodec()),
          escrow: addSelfFetchFunctions(client, getEscrowCodec()),
          globalConfig: addSelfFetchFunctions(client, getGlobalConfigCodec()),
          market: addSelfFetchFunctions(client, getMarketCodec()),
        },
        instructions: {
          cancelMarket: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCancelMarketInstruction(input),
            ),
          closeCancelledMarket: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCloseCancelledMarketInstructionAsync(input),
            ),
          closeResolvedMarket: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCloseResolvedMarketInstructionAsync(input),
            ),
          createMarket: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getCreateMarketInstructionAsync(input),
            ),
          drainOracleReqPda: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getDrainOracleReqPdaInstructionAsync(input),
            ),
          initializeConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getInitializeConfigInstructionAsync(input),
            ),
          migrateConfigV2: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getMigrateConfigV2InstructionAsync(input),
            ),
          migrateConfigV3: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getMigrateConfigV3InstructionAsync(input),
            ),
          placeBet: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getPlaceBetInstructionAsync(input),
            ),
          refundBet: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getRefundBetInstructionAsync({
                ...input,
                payer: input.payer ?? client.payer,
              }),
            ),
          settleBet: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getSettleBetInstructionAsync(input),
            ),
          updateConfig: (input) =>
            addSelfPlanAndSendFunctions(
              client,
              getUpdateConfigInstructionAsync(input),
            ),
        },
        pdas: {
          escrow: findEscrowPda,
          config: findConfigPda,
          oracleReqPda: findOracleReqPdaPda,
          bet: findBetPda,
          refundBetBet: findRefundBetBetPda,
        },
      },
    });
  };
}

type MakeOptional<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
